// list of mime types is taken from mimelite.js package
// only mime types relevant to MediaRenderer are included others are removed

const AUDIO_MPEG = "audio/mpeg";
const AUDIO_MIDI = "audio/midi";
const AUDIO_OG = "audio/ogg";
const IMG_JPEG = "image/jpeg";

export const extensionsToMimeType: Record<string, string> = {
  // audio
  "*3gpp": "audio/3gpp",
  adp: "audio/adpcm",
  amr: "audio/amr",
  au: "audio/basic",
  snd: "audio/basic",
  mid: AUDIO_MIDI,
  midi: AUDIO_MIDI,
  kar: AUDIO_MIDI,
  rmi: AUDIO_MIDI,
  mxmf: "audio/mobile-xmf",
  "*mp3": "audio/mp3",
  m4a: "audio/mp4",
  mp4a: "audio/mp4",
  mpga: AUDIO_MPEG,
  mp2: AUDIO_MPEG,
  mp2a: AUDIO_MPEG,
  mp3: AUDIO_MPEG,
  m2a: AUDIO_MPEG,
  m3a: AUDIO_MPEG,
  oga: AUDIO_OG,
  ogg: AUDIO_OG,
  spx: AUDIO_OG,
  opus: AUDIO_OG,
  s3m: "audio/s3m",
  sil: "audio/silk",
  wav: "audio/wav",
  "*wav": "audio/wave",
  weba: "audio/webm",
  // images
  xm: "audio/xm",
  exr: "image/aces",
  apng: "image/apng",
  avif: "image/avif",
  bmp: "image/bmp",
  cgm: "image/cgm",
  drle: "image/dicom-rle",
  emf: "image/emf",
  fits: "image/fits",
  g3: "image/g3fax",
  gif: "image/gif",
  heic: "image/heic",
  heics: "image/heic-sequence",
  heif: "image/heif",
  heifs: "image/heif-sequence",
  hej2: "image/hej2k",
  hsj2: "image/hsj2",
  ief: "image/ief",
  jls: "image/jls",
  jp2: "image/jp2",
  jpg2: "image/jp2",
  jpeg: IMG_JPEG,
  jpg: IMG_JPEG,
  jpe: IMG_JPEG,
  jph: "image/jph",
  jhc: "image/jphc",
  jpm: "image/jpm",
  jpx: "image/jpx",
  jpf: "image/jpx",
  jxr: "image/jxr",
  jxra: "image/jxra",
  jxrs: "image/jxrs",
  jxs: "image/jxs",
  jxsc: "image/jxsc",
  jxsi: "image/jxsi",
  jxss: "image/jxss",
  ktx: "image/ktx",
  ktx2: "image/ktx2",
  png: "image/png",
  sgi: "image/sgi",
  svg: "image/svg+xml",
  svgz: "image/svg+xml",
  t38: "image/t38",
  tif: "image/tiff",
  tiff: "image/tiff",
  tfx: "image/tiff-fx",
  webp: "image/webp",
  wmf: "image/wmf",
  // 3d models
  "3mf": "model/3mf",
  gltf: "model/gltf+json",
  glb: "model/gltf-binary",
  igs: "model/iges",
  iges: "model/iges",
  msh: "model/mesh",
  mesh: "model/mesh",
  silo: "model/mesh",
  mtl: "model/mtl",
  obj: "model/obj",
  stl: "model/stl",
  wrl: "model/vrml",
  vrml: "model/vrml",
  "*x3db": "model/x3d+binary",
  x3dbz: "model/x3d+binary",
  x3db: "model/x3d+fastinfoset",
  "*x3dv": "model/x3d+vrml",
  x3dvz: "model/x3d+vrml",
  x3d: "model/x3d+xml",
  x3dz: "model/x3d+xml",
  x3dv: "model/x3d-vrml",
  // html
  html: "text/html",
  htm: "text/html",
  shtml: "text/html",
  // videos
  "3gp": "video/3gpp",
  "3gpp": "video/3gpp",
  "3g2": "video/3gpp2",
  h261: "video/h261",
  h263: "video/h263",
  h264: "video/h264",
  m4s: "video/iso.segment",
  jpgv: "video/jpeg",
  "*jpm": "video/jpm",
  jpgm: "video/jpm",
  mj2: "video/mj2",
  mjp2: "video/mj2",
  ts: "video/mp2t",
  mp4: "video/mp4",
  mp4v: "video/mp4",
  mpg4: "video/mp4",
  mpeg: "video/mpeg",
  mpg: "video/mpeg",
  mpe: "video/mpeg",
  m1v: "video/mpeg",
  m2v: "video/mpeg",
  ogv: "video/ogg",
  qt: "video/quicktime",
  mov: "video/quicktime",
  webm: "video/webm",
  mkv: "video/x-matroska",
};
